import { render, staticRenderFns } from "./delivery.vue?vue&type=template&id=68c71d1f&scoped=true"
import script from "./delivery.vue?vue&type=script&lang=ts"
export * from "./delivery.vue?vue&type=script&lang=ts"
import style0 from "./delivery.vue?vue&type=style&index=0&id=68c71d1f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c71d1f",
  null
  
)

export default component.exports